import React, { PureComponent, createRef } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitle from '../../containers/HOC/ContainerWithTitle'
import {
  Grid,
  Button,
  ListItem,
  MenuItem,
  DialogContent,
  DialogTitle,
  Drawer,
  withStyles,
  Tooltip,
} from '@material-ui/core'
import { EditableImageUploader, ImagePreview } from '../common/ImageUploader'
import {
  EditableTextField,
  EditableSelect,
  EditableSwitch,
  EditableReactSelect,
} from '../common/EditableComponents'
import { Formik } from 'formik'
import { Appcues } from '../../utils/constants'
import { uploadAssetAPI } from '../../api/assets'
import {
  cannabisTypeOptions,
  categoryTypes,
  searchStringInArray,
  unitTypes,
} from '../../utils/common'
import { getEmployeeShops, canCreateOrEditShopLevelMasterCategory } from '../../utils/api'
import {
  addMasterCategory,
  saveChildCategories,
  getBlazeCategories,
  updateSingleMasterCategories,
  getMasterCategory,
  updateChildCategories,
  updateChildCategory,
  removeChildCategories,
} from '../../actions/masterCatalog'
import { openSuccessMessage, openErrorMessage } from '../../actions/message'
import { isValidString } from '../../utils/string'
import { getCategoryById } from '../../actions/inventory'
import InfoIcon from '@material-ui/icons/Info'
import ModalConfirmationRemoveLocation from './ModalConfirmationRemoveLocation'

let timeout
const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(13),
    border: '2px solid #dadde9',
  },
}))(Tooltip)
class FormMasterCategory extends PureComponent {
  constructor(props) {
    super(props)

    this.form = createRef()
    this.state = {
      categoryImage: '',
      shopIds: [],
      topLevels: [],
      validator: true,
      category: null,
      showConfirmationModal: null,
    }
  }
  componentDidMount() {
    this.props.dispatch(getBlazeCategories()).then((res) => {
      this.setState({ topLevels: res || [] })
    })

    const { category, updateOption, typeCategory } = this.props

    if (updateOption) {
      if (typeCategory == 'master' && !category.parentCategoryId) {
        this.props.dispatch(getMasterCategory(category.id)).then((res) => {
          const listShops =
            (res && res.childCategories && res.childCategories.map((e) => e.shop)) || []
          const listShopIds = listShops.map((shop) => shop.id)
          const shopIds = listShops.map((shop) => ({
            value: shop.id,
            label: shop.name,
          }))
          const image = res && res.photo
          this.setState({
            shopIds: shopIds,
            categoryImage: image,
            category:
              (res && {
                ...res,
                shopIds: listShopIds,
              }) ||
              null,
          })
        })
      } else {
        this.props.dispatch(getCategoryById(category.id)).then((res) => {
          const image = res && res.photo
          this.setState({
            shopIds: [],
            categoryImage: image,
            category: res || null,
          })
        })
      }
    } else {
      this.setState({
        shopIds: [],
        categoryImage: '',
        category: null,
      })
    }
  }

  uploadMasterCategoryImage = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        this.setState({
          categoryImage: response,
        })
        res(response)
      })
    })
  }

  handleChangeLocation = (currentShopIds, newShopsAux) => {
    const { shopReducer } = this.props
    const allShops =
      (shopReducer &&
        shopReducer.shopsList &&
        shopReducer.shopsList.values && [...shopReducer.shopsList.values]) ||
      []
    if (
      currentShopIds &&
      currentShopIds.length &&
      currentShopIds.find((val) => val.label == 'ADD ALL')
    ) {
      let autoSelectedShops = newShopsAux.filter((val) => {
        var auxShop = allShops.find((s) => s.id == val.value) || {}
        return val.label != 'ADD ALL' && !auxShop.deleted && auxShop.active
      })
      this.setState({ shopIds: autoSelectedShops })
    } else {
      this.setState({ shopIds: currentShopIds })
    }
  }

  saveMasterCategory = (values) => {
    const { typeCategory } = this.props
    const { category, shopIds } = this.state
    if (values.master) {
      if (!values.name || !isValidString(values.name) || !this.state.categoryImage) {
        return this.setState({ validator: false })
      }
    } else {
      if (!values.name || !isValidString(values.name)) {
        return this.setState({ validator: false })
      }
    }
    let storeIds = (shopIds && shopIds.map((shopId) => shopId.value)) || []
    values.photo = this.state.categoryImage
    values.shopIds = storeIds
    if (!category) {
      if (!storeIds || storeIds == 0) {
        return this.setState({ validator: false })
      }
      this.props.dispatch(addMasterCategory(values)).then((res) => {
        Appcues.track('Master category added')
        this.uploadMasterCategoryImage(values)
        this.props.dispatch(openSuccessMessage('Master Category created'))

        const information = {
          category: { ...res, shopIds: storeIds },
          storeIds: storeIds,
        }
        this.props
          .dispatch(saveChildCategories(information))
          .then(() => {
            this.handleCloseFormCategory()
            this.props.updateListCategory()
            this.props.dispatch(openSuccessMessage('Child categories created for ' + res.name))
          })
          .catch((err) => {
            this.props.dispatch(openErrorMessage('Child categories not created'))
          })
      })
    } else if (category.childCategories) {
      const deletedShops = category.shopIds.filter((pd) => !storeIds.includes(pd)) || []
      values.shopIds = storeIds
      if (deletedShops.length > 0) {
        this.openConfirmationModal(values)
      } else {
        this.onContinueRegisterHandler(values)
      }
    } else {
      values.id = category.id
      this.props.dispatch(updateChildCategory(values)).then((res) => {
        this.props.dispatch(
          openSuccessMessage(`${typeCategory == 'orphan' ? 'Orphan' : 'Child'} category updated`),
        )
        this.handleCloseFormCategory()
        this.props.updateListCategory()
      })
    }
  }

  openConfirmationModal = (newValues) => {
    this.setState({
      showConfirmationModal: true,
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      showConfirmationModal: false,
    })
  }

  onContinueRegisterHandler = (values) => {
    const { category, shopIds } = this.state

    let newShopValues = (shopIds && shopIds.map((shopId) => shopId.value)) || []

    const newShops = newShopValues.filter((shopId) => !category.shopIds.includes(shopId))
    const updatedShops = newShopValues.filter((shopId) => category.shopIds.includes(shopId))
    const deletedShops = category.shopIds.filter((pd) => !newShopValues.includes(pd))

    const updateCategory = { ...values, shopIds: newShopValues, edit: true }
    this.props.dispatch(updateSingleMasterCategories(updateCategory)).then(async (res) => {
      if (updatedShops.length > 0) {
        await this.props.dispatch(updateChildCategories({ ...res }, updatedShops))
      }

      if (newShops.length > 0) {
        let information = {
          category: {
            ...res,
            topLevelCategoryName: values.topLevelCategoryName,
            photo: values.photo,
          },
          storeIds: newShopValues,
        }
        await this.props.dispatch(saveChildCategories(information))
      }
      if (deletedShops.length > 0) {
        await this.props.dispatch(removeChildCategories(res, deletedShops))
      }
      timeout = setTimeout(() => {
        this.handleCloseFormCategory()
        this.props.updateListCategory()
        clearTimeout(timeout)
      }, 3000)
    }).catch((err) => {
      console.log(err)
    })
  }

  handleCloseFormCategory = () => {
    this.setState({
      categoryImage: '',
      shopIds: [],
      validator: true,
      category: null,
    })
    this.props.handleClose()
  }

  autoCompleteTolLevel = (value, setFieldValue) => {
    const { cannabisTypeList, cannabisTypeForState } = this.props
    const { topLevels } = this.state
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      const ListCannabisTypeOption = cannabisTypeForState ? cannabisTypeList : cannabisTypeOptions
      var cannabisTypeName =
        Object.keys(ListCannabisTypeOption).find((option) =>
          ListCannabisTypeOption[option].toLowerCase().match(value.toLowerCase()),
        ) || ''
      var topLevelMatch = searchStringInArray(value.trim(), topLevels || [])
      var topLevel = {}
      if (cannabisTypeName) {
        if (cannabisTypeForState) {
          topLevelMatch
            ? setFieldValue('topLevelCategoryId', topLevelMatch.id)
            : setFieldValue('topLevelCategoryId', '')
          setFieldValue('cannabisType', cannabisTypeName)
        } else {
          switch (cannabisTypeName) {
            case 'NON_CANNABIS':
              topLevel = this.state.topLevels.find((top) => top.name == 'Accessories') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'NON_CANNABIS')
              break
            case 'CBD':
              setFieldValue('topLevelCategoryId', '')
              setFieldValue('cannabisType', 'CBD')
              break
            case 'CBD_CANNABIS':
              setFieldValue('topLevelCategoryId', '')
              setFieldValue('cannabisType', 'CBD_CANNABIS')
              break
            case 'CBD_CANNABIS_FLOWER':
              topLevel = this.state.topLevels.find((top) => top.name == 'Flowers') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'CBD_CANNABIS_FLOWER')
              break
            case 'PRE_ROLL_CBD':
              topLevel = this.state.topLevels.find((top) => top.name == 'Preroll') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'PRE_ROLL_CBD')
              break
            case 'CONCENTRATE':
              topLevel = this.state.topLevels.find((top) => top.name == 'Concentrate') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'CONCENTRATE')
              break
            case 'NON_CONCENTRATE':
              setFieldValue('topLevelCategoryId', '')
              setFieldValue('cannabisType', 'NON_CONCENTRATE')
              break
            case 'PLANT':
              topLevel = this.state.topLevels.find((top) => top.name == 'Cultivation') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'PLANT')
              break
            case 'EDIBLE':
              topLevel = this.state.topLevels.find((top) => top.name == 'Edibles') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'EDIBLE')
              break
            case 'EXTRACT':
              topLevel = this.state.topLevels.find((top) => top.name == 'Concentrate') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'EXTRACT')
              break
            case 'DRY_FLOWER':
              topLevel = this.state.topLevels.find((top) => top.name == 'Flowers') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'DRY_FLOWER')
              break
            case 'KIEF':
              topLevel = this.state.topLevels.find((top) => top.name == 'Concentrate') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'KIEF')
              break
            case 'DRY_LEAF':
              topLevel = this.state.topLevels.find((top) => top.name == 'Flowers') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'DRY_LEAF')
              break
            case 'LIQUID':
              topLevel = this.state.topLevels.find((top) => top.name == 'Edibles') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'LIQUID')
              break
            case 'SUPPOSITORY':
              topLevel = this.state.topLevels.find((top) => top.name == 'Topicals') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'SUPPOSITORY')
              break
            case 'TINCTURE':
              topLevel = this.state.topLevels.find((top) => top.name == 'Edibles') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'TINCTURE')
              break
            case 'TOPICAL':
              topLevel = this.state.topLevels.find((top) => top.name == 'Topicals') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'TOPICAL')
              break
            case 'OIL':
              topLevel = this.state.topLevels.find((top) => top.name == 'Concentrate') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'OIL')
              break
            case 'SEEDS':
              topLevel = this.state.topLevels.find((top) => top.name == 'Cultivation') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'SEEDS')
              break
            case 'PRE_ROLL':
              topLevel = this.state.topLevels.find((top) => top.name == 'Preroll') || {}
              setFieldValue('topLevelCategoryId', topLevel.id)
              setFieldValue('cannabisType', 'PRE_ROLL')
              break
            default:
              setFieldValue('topLevelCategoryId', '')
              setFieldValue('cannabisType', 'DEFAULT')
              break
          }
        }
      } else {
        if (topLevelMatch) {
          if (cannabisTypeForState) {
            setFieldValue('topLevelCategoryId', '')
            setFieldValue('cannabisType', 'DEFAULT')
          } else {
            switch (topLevelMatch.name) {
              case 'Accessories':
                setFieldValue('topLevelCategoryId', topLevelMatch.id)
                setFieldValue('cannabisType', 'NON_CANNABIS')
                break
              case 'Preroll':
                setFieldValue('topLevelCategoryId', topLevelMatch.id)
                setFieldValue('cannabisType', 'PRE_ROLL')
                break
              case 'VapePens':
                setFieldValue('topLevelCategoryId', topLevelMatch.id)
                setFieldValue('cannabisType', 'CONCENTRATE')
                break
              case 'Cultivation':
                setFieldValue('topLevelCategoryId', topLevelMatch.id)
                setFieldValue('cannabisType', 'SEEDS')
                break
              default:
                setFieldValue('topLevelCategoryId', '')
                setFieldValue('cannabisType', 'DEFAULT')
                break
            }
          }
        } else {
          setFieldValue('topLevelCategoryId', '')
          setFieldValue('cannabisType', 'DEFAULT')
        }
      }
      clearTimeout(timeout)
    }, 1000)
  }

  setCannabysTipe = (value, setFieldValue) => {
    const { cannabisTypeForState } = this.props
    var topLevelMatch = this.state.topLevels.find((top) => top.id == value) || []
    if (topLevelMatch && !cannabisTypeForState) {
      switch (topLevelMatch.name) {
        case 'VapePens':
        case 'Concentrate':
          setFieldValue('cannabisType', 'CONCENTRATE')
          break
        case 'Accessories':
          setFieldValue('cannabisType', 'NON_CANNABIS')
          break
        case 'Cultivation':
          setFieldValue('cannabisType', 'PLANT')
          break
        case 'Edibles':
          setFieldValue('cannabisType', 'EDIBLE')
          break
        case 'Flowers':
          setFieldValue('cannabisType', 'CBD_CANNABIS_FLOWER')
          break
        case 'Preroll':
          setFieldValue('cannabisType', 'PRE_ROLL')
          break
        case 'Topicals':
          setFieldValue('cannabisType', 'TOPICAL')
          break
        default:
          setFieldValue('cannabisType', 'DEFAULT')
          break
      }
    }
  }

  handleChangeLit = (event, setFieldValue) => {
    const onlyNumbers = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/
    if (event.target.value == '' || onlyNumbers.test(event.target.value)) {
      setFieldValue('lowThreshold', event.target.value)
    }
  }

  getDefaultValues = (category, updateOption) => {
    let defaultValues
    if (category && updateOption) {
      if (category.childCategories) {
        defaultValues = {
          ...category,
          master: true,
        }
      } else {
        defaultValues = {
          ...category,
          master: false,
        }
      }
    } else {
      defaultValues = {
        name: '',
        cannabis: false,
        topLevelCategoryId: ' ',
        complianceId: '',
        unitType: 'units',
        lowThreshold: 0,
        active: true,
        cannabisType: 'DEFAULT',
        master: true,
      }
    }
    return defaultValues
  }

  render() {
    const {
      open,
      updateOption,
      typeCategory,
      shopReducer,
      cannabisTypeList,
      cannabisTypeForState,
    } = this.props
    const { categoryImage, shopIds, topLevels, validator, category, showConfirmationModal } =
      this.state
    const permittedShopLevelMasterCategory = canCreateOrEditShopLevelMasterCategory()
    const employeeShops = getEmployeeShops()

    let defaultValues = this.getDefaultValues(category, updateOption)
    const categoryCase = updateOption
      ? typeCategory == 'orphan'
        ? 'orphan'
        : category && category.parentCategoryId
        ? 'child'
        : 'master'
      : 'master'
    const allShops =
      (shopReducer &&
        shopReducer.shopsList &&
        shopReducer.shopsList.values && [...shopReducer.shopsList.values]) ||
      []
    let newShopsAux = []
    if (allShops) {
      newShopsAux = allShops
        .filter((s) => !s.deleted && s.name)
        .map((shop) => ({
          value: shop.id,
          label: shop.name,
          disabled:
            (permittedShopLevelMasterCategory ? !employeeShops.includes(shop.id) : false) ||
            !shop.active ||
            shop.deleted,
        }))
      newShopsAux.unshift({ label: 'ADD ALL', value: '0', clearableValue: true })
    }

    var sourceMap = defaultValues.sourceMap || {}

    const ListCannabisTypeOption = cannabisTypeForState ? cannabisTypeList : cannabisTypeOptions

    return (
      <Drawer anchor="right" open={open} onClose={this.handleCloseFormCategory}>
        <div className="formMasterProduct-Category">
          <Formik
            enableReinitialize
            innerRef={this.form}
            initialValues={{ ...defaultValues }}
            onSubmit={this.saveMasterCategory}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <div>
                  <form>
                    <DialogTitle id="scroll-dialog-title">
                      {updateOption
                        ? categoryCase == 'orphan'
                          ? 'Update Orphan Category'
                          : categoryCase == 'child'
                          ? 'Update Child Category'
                          : 'Update Master Category'
                        : 'Create a New Master Category'}
                    </DialogTitle>

                    <DialogContent style={{ height: '770px' }}>
                      {categoryCase == 'master' && (
                        <ListItem>
                          <Grid container className="center-aligned-child">
                            <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                              <Grid
                                container
                                alignItems="center"
                                alignContent="center"
                                justify="flex-start"
                                direction="row"
                              >
                                <label className="label-modal">
                                  {!updateOption ? 'Locations*' : 'Locations  '}
                                </label>
                                {updateOption ? (
                                  <HtmlTooltip
                                    placement="top-center"
                                    title={`The Master Category will be archived automatically when the last child category is deleted.`}
                                  >
                                    <InfoIcon style={{ color: '#03a9f4', fontSize: 19 }} />
                                  </HtmlTooltip>
                                ) : null}
                              </Grid>
                            </Grid>
                            <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                              <EditableReactSelect
                                menuContainerStyle={{ zIndex: 5 }}
                                className="custom-select"
                                multi={true}
                                material={false}
                                value={shopIds}
                                onChange={(value) => {
                                  this.handleChangeLocation(value, newShopsAux)
                                }}
                                editMode={true}
                                InputLabelProps={{ shrink: true }}
                                options={newShopsAux}
                                placeholder="Search"
                                clearable={true}
                              ></EditableReactSelect>
                              {!validator && this.state.shopIds.length == 0 && (
                                <span style={{ color: 'red' }}>Stores is required</span>
                              )}
                            </Grid>
                          </Grid>
                        </ListItem>
                      )}
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Status</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableSwitch
                              id="active"
                              editMode={true}
                              onChange={(event, value) => {
                                setFieldValue('active', value)
                              }}
                              checked={values.active}
                              disabled={sourceMap.active == 'PARENT'}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" xs={12} sm={5} md={5} item lg={5}>
                            {defaultValues.master ? (
                              <label className="label-modal">Image Preview *</label>
                            ) : (
                              <label className="label-modal">Image Preview</label>
                            )}
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableImageUploader
                              editMode={true}
                              valueToRender={
                                <ImagePreview
                                  src={
                                    (categoryImage &&
                                      (categoryImage.thumbURL || categoryImage.publicURL)) ||
                                    ''
                                  }
                                />
                              }
                              src={
                                (categoryImage &&
                                  (categoryImage.thumbURL || categoryImage.publicURL)) ||
                                ''
                              }
                              imageUploadAPI={this.uploadMasterCategoryImage}
                              hideButton={sourceMap.photo == 'PARENT'}
                            />
                            {defaultValues.master
                              ? !validator &&
                                !this.state.categoryImage && (
                                  <span style={{ color: 'red' }}>Image is required</span>
                                )
                              : null}
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Category Name *</label>
                          </Grid>
                          <Grid item xs={12} sm={7} md={7} lg={7}>
                            <EditableTextField
                              id="name"
                              onChange={(e) => {
                                setFieldValue('name', e.target.value)
                                this.autoCompleteTolLevel(e.target.value, setFieldValue)
                              }}
                              value={values.name}
                              placeholder="Enter Name"
                              material={false}
                              editMode={true}
                              disabled={categoryCase == 'child'}
                            />
                            {!validator && !isValidString(values.name) && (
                              <span style={{ color: 'red' }}>Category Name is required</span>
                            )}
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Top Level</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableSelect
                              id="topLevelCategoryId"
                              onChange={(e) => {
                                setFieldValue('topLevelCategoryId', e.target.value)
                                this.setCannabysTipe(e.target.value, setFieldValue)
                              }}
                              value={values.topLevelCategoryId}
                              material={false}
                              editMode={true}
                              disabled={sourceMap.topLevelCategoryName == 'PARENT'}
                            >
                              <MenuItem value={' '}>Not Assigned</MenuItem>
                              {topLevels.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                )
                              })}
                            </EditableSelect>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Category Type</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableSelect
                              id="cannabis"
                              onChange={(e) => {
                                setFieldValue('cannabis', e.target.value)
                              }}
                              value={values.cannabis}
                              material={false}
                              editMode={true}
                              disabled={sourceMap.cannabis == 'PARENT'}
                            >
                              {categoryTypes.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                )
                              })}
                            </EditableSelect>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Cannabis Type</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableSelect
                              id="cannabisType"
                              value={values.cannabisType}
                              onChange={(e) => {
                                setFieldValue('cannabisType', e.target.value)
                              }}
                              material={false}
                              editMode={true}
                            >
                              {Object.keys(ListCannabisTypeOption).map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item}>
                                    {ListCannabisTypeOption[item]}
                                  </MenuItem>
                                )
                              })}
                            </EditableSelect>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Measurement</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableSelect
                              value={values.unitType}
                              onChange={(e) => {
                                setFieldValue('unitType', e.target.value)
                              }}
                              material={false}
                              editMode={true}
                              disabled={sourceMap.unitType == 'PARENT'}
                            >
                              {unitTypes.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                )
                              })}
                            </EditableSelect>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <Grid container className="center-aligned-child">
                          <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                            <label className="label-modal">Low Inventory Threshold</label>
                          </Grid>
                          <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                            <EditableTextField
                              id="lowThreshold"
                              editMode={true}
                              value={values.lowThreshold}
                              onChange={(event) => this.handleChangeLit(event, setFieldValue)}
                              material={false}
                              placeholder="---"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled={sourceMap.lowThreshold == 'PARENT'}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </DialogContent>
                  </form>

                  <div className="container-form-buttons">
                    <Button onClick={this.handleCloseFormCategory} className="button-white-and-red">
                      <span className="button-text">Cancel</span>
                    </Button>
                    <Button type="submit" className="button-blue-and-white" onClick={handleSubmit}>
                      <span className="button-text">{!updateOption ? 'Create' : 'Update'}</span>
                    </Button>
                  </div>
                  <ModalConfirmationRemoveLocation
                    open={showConfirmationModal}
                    close={this.closeConfirmationModal}
                    confirmUpdate={() => {
                      this.onContinueRegisterHandler(values)
                    }}
                    categoryData={category}
                  />
                </div>
              )
            }}
          </Formik>
        </div>
      </Drawer>
    )
  }
}

const MasterCatalogWithTitle = ContainerWithTitle(FormMasterCategory, 'Form Master Category')

const MasterCatalogConnected = connect(({ dispatch, masterCatalogReducer, shopReducer }) => ({
  dispatch,
  masterCatalogReducer,
  shopReducer,
}))(MasterCatalogWithTitle)

export default MasterCatalogConnected



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/FormMasterCategory.js